/**
 * Shared JO Status badge colors and helper utility.
 * Single source of truth used by NI Dashboard and Migration pages.
 */

export const JO_STATUS_COLORS = {
  Pending:     "bg-yellow-100 text-yellow-800",
  Completed:   "bg-green-100 text-green-800",
  Cancelled:   "bg-red-100 text-red-800",
  Rescheduled: "bg-blue-100 text-blue-800",
};

/** Fallback badge style for unknown / unmapped JO statuses */
export const JO_STATUS_DEFAULT_COLOR = "bg-gray-100 text-gray-700";

/**
 * Get the badge color classes for a jo_status value.
 * Returns the mapped color for known statuses, or the default for others.
 */
export function getJoStatusColor(value) {
  if (!value) return "";
  return JO_STATUS_COLORS[value] || JO_STATUS_DEFAULT_COLOR;
}
